import { defineMessages, type MessageDescriptor } from 'react-intl-next';

export type RemoteLinkSubtype = 'task' | 'dashboard' | 'invoice' | 'design' | 'deal';

export const messages: Record<RemoteLinkSubtype | string, MessageDescriptor> = defineMessages({
	task: {
		id: 'search-page.task.label',
		defaultMessage: 'Task',
		description: 'A label for remote link work item results.',
	},
	dashboard: {
		id: 'search-page.dashboard.label',
		defaultMessage: 'Dashboard',
		description: 'A label for remote link dashboard results.',
	},
	invoice: {
		id: 'search-page.invoice.label',
		defaultMessage: 'Invoice',
		description: 'A label for remote link invoice results.',
	},
	design: {
		id: 'search-page.design.label',
		defaultMessage: 'Design',
		description: 'A label for remote link design results.',
	},
	deal: {
		id: 'search-page.deal.label',
		defaultMessage: 'Deal',
		description: 'A label for remote link deal results.',
	},
});
